/* Nika Atelier — theme scripts */
(function () {
  'use strict';

  var theme = window.theme || {};
  var desktop = window.matchMedia('(min-width: 990px)');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      if (precision === undefined) precision = 2;
      if (thousands === undefined) thousands = ',';
      if (decimal === undefined) decimal = '.';
      if (isNaN(number) || number == null) return '0';
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(placeholder);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- Drawers ---------- */
  var lastTrigger = null;
  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    lastTrigger = trigger || null;
    drawer.classList.add('is-open');
    document.body.classList.add('has-drawer');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var focusable = $('button, a, input', drawer.querySelector('.drawer__panel'));
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawers() {
    $$('[data-drawer].is-open').forEach(function (d) { d.classList.remove('is-open'); });
    document.body.classList.remove('has-drawer');
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { closeDrawers(); return; }

    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var bar = $('[data-search-bar]');
      if (!bar) return;
      bar.hidden = !bar.hidden;
      if (!bar.hidden) { var input = $('input[type="search"]', bar); if (input) input.focus(); }
      return;
    }

    var dialogOpen = e.target.closest('[data-dialog-open]');
    if (dialogOpen) {
      var dialog = document.getElementById(dialogOpen.getAttribute('data-dialog-open'));
      if (dialog && dialog.showModal) dialog.showModal();
      return;
    }
    if (e.target.closest('[data-dialog-close]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
      return;
    }
    if (e.target.tagName === 'DIALOG') { e.target.close(); return; }

    var zoom = e.target.closest('[data-zoom]');
    if (zoom) {
      var lb = $('[data-lightbox]');
      if (lb && lb.showModal) {
        var img = $('[data-lightbox-img]', lb);
        img.src = zoom.getAttribute('data-zoom');
        var inner = $('img', zoom);
        img.alt = inner ? inner.alt : '';
        lb.showModal();
      }
      return;
    }

    var recover = e.target.closest('[data-recover-toggle]');
    if (recover) {
      var r = document.getElementById('recover');
      if (r) { e.preventDefault(); r.classList.toggle('is-open'); }
    }

    var qtyBtn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (qtyBtn) {
      var wrap = qtyBtn.closest('[data-qty]');
      var field = $('input', wrap);
      var min = parseInt(field.min || '0', 10);
      var val = parseInt(field.value || '0', 10) + (qtyBtn.hasAttribute('data-qty-plus') ? 1 : -1);
      field.value = Math.max(min, val);
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  /* ---------- Announcement ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------- Auto-submit (sort, cart quantities, filters) ---------- */
  function cleanAndSubmit(form) {
    $$('input, select', form).forEach(function (el) { if (el.value === '' && el.name) el.disabled = true; });
    form.submit();
  }
  var cartTimer;
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches('[data-sort-form] select')) { cleanAndSubmit(el.form); return; }
    if (el.matches('[data-cart-form] [data-autosubmit]')) {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () { el.form.submit(); }, 450);
      return;
    }
    var filters = el.closest('[data-filters-form]');
    if (filters && desktop.matches && filters.closest('.collection--sidebar')) cleanAndSubmit(filters);
  });
  document.addEventListener('submit', function (e) {
    if (e.target.matches('[data-filters-form]')) {
      $$('input', e.target).forEach(function (el) { if (el.value === '' && el.name) el.disabled = true; });
    }
  });

  /* ---------- Cart count + toast ---------- */
  function refreshCartCount() {
    return fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      });
  }
  var toastTimer;
  function toast(text) {
    var t = $('[data-toast]');
    if (!t) return;
    $('[data-toast-text]', t).textContent = text;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 4500);
  }

  /* ---------- Product ---------- */
  function ProductSection(el) {
    this.el = el;
    var json = $('[data-product-json]', el);
    if (!json) return;
    this.product = JSON.parse(json.textContent);
    var inv = $('[data-inventory-json]', el);
    try { this.inventory = inv ? JSON.parse(inv.textContent) : {}; } catch (err) { this.inventory = {}; }
    this.picker = $('[data-variant-picker]', el);
    this.form = $('[data-product-form]', el);
    this.track = $('[data-gallery-track]', el);
    this.dots = $$('.gallery__dot', el);

    if (this.picker) {
      this.picker.addEventListener('change', this.onOptionChange.bind(this));
      this.updateAvailability();
    }
    if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
    if (this.track && this.dots.length) this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
  }

  ProductSection.prototype.selected = function () {
    return $$('fieldset', this.picker).map(function (fs) {
      var c = $('input:checked', fs);
      return c ? c.value : null;
    });
  };

  ProductSection.prototype.findVariant = function (opts) {
    return this.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  };

  ProductSection.prototype.updateAvailability = function () {
    var self = this;
    var current = this.selected();
    $$('fieldset', this.picker).forEach(function (fs, index) {
      $$('input', fs).forEach(function (input) {
        var available = self.product.variants.some(function (v) {
          if (!v.available || v.options[index] !== input.value) return false;
          return v.options.every(function (o, i) { return i === index || current[i] === null || o === current[i]; });
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !available);
      });
    });
  };

  ProductSection.prototype.onOptionChange = function () {
    var opts = this.selected();
    $$('fieldset', this.picker).forEach(function (fs, i) {
      var s = $('[data-option-selected]', fs);
      if (s) s.textContent = opts[i] || '';
    });
    this.updateAvailability();
    var variant = this.findVariant(opts);
    if (!variant) { this.setButton(false, theme.strings.unavailable); return; }

    var idInput = $('[data-variant-id]', this.el);
    if (idInput) idInput.value = variant.id;
    this.setButton(variant.available, variant.available ? theme.strings.addToCart : theme.strings.soldOut);
    this.updatePrice(variant);
    this.updateStock(variant);
    if (variant.featured_media) this.showMedia(variant.featured_media.id);

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  ProductSection.prototype.setButton = function (enabled, text) {
    var btn = $('[data-add-button]', this.el);
    if (!btn) return;
    btn.disabled = !enabled;
    var t = $('[data-add-text]', btn);
    if (t) t.textContent = text;
  };

  ProductSection.prototype.updatePrice = function (variant) {
    var box = $('.product__price [data-price]', this.el);
    if (!box) return;
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    box.classList.toggle('price--sale', !!onSale);
    box.classList.toggle('price--sold-out', !variant.available);
    var current = $('[data-price-current]', box);
    if (current) current.innerHTML = formatMoney(variant.price);
    var compare = $('[data-price-compare]', box);
    if (compare) {
      compare.hidden = !onSale;
      if (onSale) compare.innerHTML = formatMoney(variant.compare_at_price);
    }
    var badge = $('[data-price-badge]', box);
    if (badge) {
      badge.hidden = !onSale;
      if (onSale) badge.textContent = '−' + Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + ' %';
    }
  };

  ProductSection.prototype.updateStock = function (variant) {
    var note = $('[data-stock-note]', this.el);
    if (!note) return;
    var qty = this.inventory[String(variant.id)];
    var threshold = parseInt(note.getAttribute('data-threshold'), 10) || 0;
    note.hidden = !(qty !== null && qty !== undefined && qty > 0 && qty <= threshold);
  };

  ProductSection.prototype.showMedia = function (id) {
    var item = $('[data-media-id="' + id + '"]', this.el);
    if (!item || !this.track) return;
    if (desktop.matches) {
      if (this.track.firstElementChild !== item) this.track.insertBefore(item, this.track.firstElementChild);
    } else {
      this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }
  };

  ProductSection.prototype.onScroll = function () {
    var w = this.track.clientWidth || 1;
    var index = Math.round(this.track.scrollLeft / w);
    this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
  };

  ProductSection.prototype.onSubmit = function (e) {
    if (!window.fetch) return;
    e.preventDefault();
    var form = this.form;
    var btn = $('[data-add-button]', form);
    var error = $('[data-form-error]', form);
    if (error) error.hidden = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || theme.strings.error);
        toast(theme.strings.added);
        return refreshCartCount();
      })
      .catch(function (err) {
        if (error) { error.textContent = err.message || theme.strings.error; error.hidden = false; }
      })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  };

  $$('[data-product-section]').forEach(function (el) { new ProductSection(el); });

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* ---------- Address forms ---------- */
  $$('select[data-default]').forEach(function (sel) {
    var v = sel.getAttribute('data-default');
    if (v) sel.value = v;
  });

  /* ---------- Theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(function (el) { new ProductSection(el); });
  });
})();
